import {DEMO_REQUEST_PATH} from '@/components/www/demo-request/demoPage'

export type LandingCta = {
    label: string
    to: string
}

export const DEFAULT_LANDING_CTA: LandingCta = {
    label: 'Get a demo',
    to: DEMO_REQUEST_PATH,
}

export function isLandingChrome(meta: {landingChrome?: unknown} | undefined): boolean {
    return meta?.landingChrome === true
}

export function landingCtaFromMeta(meta: {landingCta?: unknown} | undefined): LandingCta {
    const cta = meta?.landingCta
    if (
        cta
        && typeof cta === 'object'
        && 'label' in cta
        && 'to' in cta
        && typeof (cta as LandingCta).label === 'string'
        && typeof (cta as LandingCta).to === 'string'
    ) {
        return cta as LandingCta
    }
    return DEFAULT_LANDING_CTA
}

declare module 'vue-router' {
    interface RouteMeta {
        headerTheme?: 'light' | 'dark'
        headerCompact?: boolean
        landingChrome?: boolean
        landingCta?: LandingCta
        /** Click id for the landing-header CTA. Omit to keep `demo_request`. */
        landingCtaId?: string
        /** Logo destination when it should leave the page. Omit to stay on this route. */
        landingLogoTo?: string
        /** Accessible name for the logo link. */
        landingLogoLabel?: string
        /** Shorter landing header after the page scrolls. */
        landingHeaderSlim?: boolean
    }
}
